var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChassis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 33,
    viewBox: "0 0 72 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.374 17.6779C16.6415 17.6779 20.1259 21.0309 20.3365 25.2461H47.5153C47.7259 21.0309 51.2103 17.6779 55.4778 17.6779C59.7453 17.6779 63.2297 21.0309 63.4403 25.2461H70.9516C71.1008 25.2461 71.2218 25.1251 71.2218 24.9759V21.1259C71.2218 21.0052 71.1418 20.8991 71.0258 20.866L68.5801 20.1672C68.4641 20.1341 68.3841 20.028 68.3841 19.9074V12.3413C68.3841 12.1921 68.2631 12.0711 68.1139 12.0711H28.7914C28.1944 12.0711 27.7104 11.5871 27.7104 10.99V0.517572C27.7104 0.368313 27.5894 0.247314 27.4402 0.247314H13.7314C13.6425 0.247314 13.5593 0.290977 13.5089 0.364105L6.26384 10.8661C6.23832 10.9031 6.20398 10.9331 6.16393 10.9535L2.5215 12.8067C2.43087 12.8528 2.37379 12.9459 2.37379 13.0476V20.6517C2.37379 20.801 2.25279 20.922 2.10353 20.922H0.549554C0.400295 20.922 0.279297 21.043 0.279297 21.1923V24.9759C0.279297 25.1251 0.400295 25.2461 0.549554 25.2461H4.41149C4.62209 21.0309 8.10648 17.6779 12.374 17.6779ZM10.8819 8.4795L14.6599 2.53384C14.7094 2.4558 14.7955 2.40852 14.888 2.40852H21.2257C21.3749 2.40852 21.4959 2.52952 21.4959 2.67878V8.62444C21.4959 8.7737 21.3749 8.8947 21.2257 8.8947H11.11C10.8968 8.8947 10.7676 8.65943 10.8819 8.4795Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3745,
    cy: 25.6505,
    r: 4.86463,
    stroke: "#BABABA",
    strokeWidth: 2.97283
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.48,
    cy: 25.6505,
    r: 4.86463,
    stroke: "#BABABA",
    strokeWidth: 2.97283
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChassis);
export default ForwardRef;